import { useRef, useEffect } from 'react';
import { formatBytes } from '../../utilities/format';

/**
 * Liquid-fill gauge (byte volume) — extracted from PreProcessingTab so the project and
 * per-collection overviews share one implementation. Wraps the legacy global
 * `window.liquidFillGauge` (custom d3 plugin loaded by the Angular vendor bundle); the
 * recursive wave animation is interrupted on unmount/update via `window.d3`.
 */
export function LiquidGauge({ value, total }: { value: number; total: number }) {
  const containerRef = useRef<HTMLDivElement>(null);
  const id = useRef(`gauge-${Math.random().toString(36).slice(2)}`).current;

  useEffect(() => {
    const container = containerRef.current;
    if (!container || value <= 0 || total <= 0) return;
    container.innerHTML = '';
    const svg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
    svg.setAttribute('id', id);
    svg.style.cssText = 'width:250px;height:323px;display:initial';
    container.appendChild(svg);
    const config = {
      minValue: 0,
      maxValue: total + total * 0.2,
      circleThickness: 0.05,
      circleFillGap: 0.05,
      circleColor: '#178BCA',
      waveHeight: 0.03,
      waveCount: 1,
      waveRiseTime: 1000,
      waveAnimateTime: 1000,
      waveRise: true,
      waveHeightScaling: true,
      waveAnimate: true,
      waveColor: '#178BCA',
      waveOffset: 0,
      textVertPosition: 0.5,
      textSize: 0.7,
      valueCountUp: false,
      displayPercent: false,
      textColor: '#045681',
      waveTextColor: '#A4DBf8',
    };
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    new (window as any).liquidFillGauge().loadLiquidFillGauge(
      { attr: (name: string) => (name === 'id' ? id : '') },
      value,
      formatBytes(value),
      config,
    );

    return () => {
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      const d3 = (window as any).d3;
      if (d3) {
        const sel = d3.select('#' + id);
        sel.interrupt();
        sel.selectAll('*').interrupt();
      }
      container.innerHTML = '';
    };
  }, [value, total, id]);

  return <div ref={containerRef} style={{ display: 'inline-block', width: 250, height: 323 }} />;
}
